import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
    Link, useNavigate, useParams,
} from "react-router-dom";
import MInput from '../../Components/Input';
import MTable from '../../Components/MTable/MTable';
import Overlay from '../../Components/Overlay';
import MTextarea from '../../Components/TextArea';
import Moment from 'react-moment';
import moment from 'moment';
import { getListProduk } from '../../Service/SalesService';
import MSelect from '../../Components/MSelect';
import { handlerFormError } from '../../Utils/Utils';
import Swal from 'sweetalert2';
import { getGoodReceiptByID, receiveGoodIssue } from '../../Service/InventoryService';
import { empty_data, print } from '../../Images';
import PrintTransfer from './PrintTransfer';
import { useReactToPrint } from 'react-to-print';

let processingId = -1;
const { $, setupDigitInput } = window;

const ReceiptView = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    let { userInfo } = useSelector(state => state.auth);
    const { user_id, user_warehouse_stock, warehouse_stock_name, user_warehouse_display, warehouse_display_name } = userInfo;
    const componentRef = useRef();

    const [state, setStates] = useState({
        processing: false,
        showProduct: false,
        created_date: '',
        products: [],
        docnum: '',
        from: '',
        fromWhsName: '',
        to: '',
        toWhsName: '',
        consignee: '',
        remark: '',
        toWarehouses: [],
        status: '',
        errors: {
            from: '',
            to: '',
            consignee: '',
            products: ''
        },
        processing: false
    });

    const setState = value => {
        setStates({ ...state, ...value });
    }

    useEffect(() => {
        getGoodReceiptByID(id).then(response => {
            const { docnum, fromwhscode, fromwhsname, towhscode, towhsname, consignee, line_items, created_date, status, remark } = response.data;
            const _products = line_items.map(e => ({
                itemno: e.itemcode,
                itemname: e.dscription,
                qty: e.qty,
            }));
            setState({
                docnum,
                from: fromwhscode,
                fromWhsName: fromwhsname,
                to: towhscode,
                toWhsName: towhsname,
                consignee,
                products: _products,
                created_date,
                status,
                remark
            });
        })
    }, []);

    const renderStatus = () => {
        var text = "";
        if (status == 'CANCELED') {
            text = <span className="badge bg-red me-2" style={{ fontSize: 12, fontWeight: 'bold', padding: 12 }}>CANCELED</span>;
        } else if (status == 'CLOSED') {
            text = <span className="badge bg-close me-2 d-block" style={{ fontSize: 12, fontWeight: 'bold', padding: 12 }}>CLOSED</span>;
        } else if (status == 'OPEN') {
            text = <span className="badge bg-cyan me-2 d-block" style={{ fontSize: 12, fontWeight: 'bold', padding: 12 }}>OPEN</span>;
        }
        return text;
    }

    const onGoback = () => {
        navigate(-1);
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
    });

    const {
        products,
        toWarehouses,
        docnum,
        from,
        to,
        consignee,
        fromWhsName,
        toWhsName,
        errors,
        processing,
        created_date,
        status,
        remark
    } = state;

    const propsPrint = { getState: state, login: userInfo }

    return (
        <div className="content-wrapper">

            <Overlay display={processing} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                                <h2 className="title-breadcrum mr-3">Transfer #{docnum}
                                {/* { 
                                <>
                                    <div style={{display: 'none'}}>
                                        <PrintTransfer  ref={componentRef} {...propsPrint}/>
                                    </div>
                                    <div style={{float: 'right', cursor: 'pointer'}}>
                                        <img src={print} onClick={handlePrint} />
                                    </div>
                                </>
                                } */}
                                </h2> {renderStatus()}
                            
                            <p>Date: {created_date}</p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 bg-white">
                            <h6 className="m-0 title-breadcrum tx-gray" >
                                Warehouse
                            </h6>
                        </div>
                        <div className="card-body" >
                            <div className="row" style={{ margin: '0 40px' }}>
                                <div className="col-md-4" >
                                    <label>From Warehouse</label>
                                    <div className="form-control">{fromWhsName}</div>
                                </div>
                                <div className="col-md-4">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                                        <div style={{ width: '100%', height: 2, borderBottom: 'dotted 2px #aaa' }} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label>To Warehouse</label>
                                    <div className="form-control">{toWhsName}</div>
                                </div>
                            </div>
                            <div className="row mb-4" style={{ margin: '0 40px' }}>
                                <div className="col-md-4">
                                    <div className="">
                                        <label>Consignee</label>
                                        <div className="form-control">{consignee}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {products && products.length > 0 &&
                        <>
                            <div className="card shadow mb-4">
                                <div className="card-header py-3 bg-white">
                                    <div className='row'>
                                        <div className='col-sm-8'>
                                            <h6 className="m-0 title-breadcrum tx-gray" >Detail Product</h6>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th className='th-no-border'>No</th>
                                                    <th className='th-no-border'>Product</th>
                                                    <th className='th-no-border' style={{ width: 100, textAlign: 'center' }}>Qty</th>
                                                    <th className='th-no-border'></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {state.products.map((item, index) => (
                                                    <tr key={`tr-` + index} >
                                                        <td style={{ paddingTop: 20 }}>{index + 1}</td>
                                                        <td style={{ paddingTop: 20 }}> {`${item.itemname} (${item.itemno})`} </td>
                                                        <td style={{ textAlign: 'center', paddingTop: 20 }}>
                                                            {item.qty}
                                                        </td>
                                                        <td>

                                                            <div>
                                                                {/* <button className="btn btn-outline-warning"
                                                                    style={{ border: 'dotted', marginBottom: 10, width: 100 }} type="button">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
                                                                        <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM4 4h1v1H4V4Z" />
                                                                        <path d="M7 2H2v5h5V2ZM3 3h3v3H3V3Zm2 8H4v1h1v-1Z" />
                                                                        <path d="M7 9H2v5h5V9Zm-4 1h3v3H3v-3Zm8-6h1v1h-1V4Z" />
                                                                        <path d="M9 2h5v5H9V2Zm1 1v3h3V3h-3ZM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8Zm2 2H9V9h1v1Zm4 2h-1v1h-2v1h3v-2Zm-4 2v-1H8v1h2Z" />
                                                                        <path d="M12 9h2V8h-2v1Z" />
                                                                    </svg>&nbsp;Scan
                                                                </button> */}
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    </div>
                                    <div className='row' style={{ marginBottom: 50 }}>
                                        <div className='col-sm-7'>

                                        </div>
                                        <div className='col-sm-5'>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </>
                    }
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 bg-white">
                            <h6 className="m-0 title-breadcrum tx-gray" >
                                Remark
                            </h6>
                        </div>
                        <div className="card-body" >
                            <div className="row mb-4" style={{ margin: '0 20px' }}>
                                <div className="col-md-6">
                                    <div className="">
                                        <label>Remark</label>
                                        <div className="form-control" style={{ height: 100 }}>{remark}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group ' style={{ width: '100%' }}>
                            <div className='d-flex justify-content-end' style={{ margin: '0 20px' }}>
                                <button type='button' className='btn btn-outline-dark' style={{ width: 150, marginRight: 20 }} onClick={onGoback}><i className='fa fa-reply' /> Back</button>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );

};

export default ReceiptView; 
